__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "saas-focus-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@conviron/saas-frontend-common", "2.0.18-qa.0", () => (Promise.all([__webpack_require__.e(2288), __webpack_require__.e(3723), __webpack_require__.e(535), __webpack_require__.e(100), __webpack_require__.e(9299), __webpack_require__.e(2440), __webpack_require__.e(260), __webpack_require__.e(9054), __webpack_require__.e(6859), __webpack_require__.e(6657), __webpack_require__.e(4480), __webpack_require__.e(8450), __webpack_require__.e(8416), __webpack_require__.e(5898), __webpack_require__.e(9238), __webpack_require__.e(4826), __webpack_require__.e(1051), __webpack_require__.e(7561), __webpack_require__.e(6531)]).then(() => (() => (__webpack_require__(98450))))));
			register("heic2any", "0.0.4", () => (__webpack_require__.e(1616).then(() => (() => (__webpack_require__(1616))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(3935), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(365), __webpack_require__.e(8416)]).then(() => (() => (__webpack_require__(50365))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(6706), __webpack_require__.e(8416), __webpack_require__.e(1051)]).then(() => (() => (__webpack_require__(86706))))));
			register("react-router-dom", "6.21.3", () => (Promise.all([__webpack_require__.e(9818), __webpack_require__.e(8416), __webpack_require__.e(1051)]).then(() => (() => (__webpack_require__(49818))))));
			register("react", "18.2.0", () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))));
			register("reflect-metadata", "0.1.14", () => (__webpack_require__.e(8660).then(() => (() => (__webpack_require__(28660))))));
			register("tsyringe", "4.8.0", () => (__webpack_require__.e(8346).then(() => (() => (__webpack_require__(78346))))));
			initExternal(52325);
			initExternal(71757);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};